import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router';

// Material UI
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

// Local
import Dropzone from './Dropzone';
import { addAsset } from '../modules';

export class AddAsset2 extends PureComponent {
  state = {
    fileCount: 0,
  };

  render() {
    const { isOpen, onClose, match } = this.props;
    return (
      <Dialog open={isOpen} onClose={onClose} fullWidth>
        <DialogTitle>Add Asset</DialogTitle>
        <DialogContent>
          <Dropzone
            id="dropzone"
            parallelUpload
            orientation="vertical"
            dropText="Drop your assets here or click to select"
            accept={
              'video/3gpp, video/mp4, video/mpeg, video/ogg, ' +
              'video/quicktime, video/webm, video/x-m4v, ' +
              'video/ms-asf, video/x-ms-wmv, video/x-msvideo, ' +
              'audio/basic, auido/L24, audio/mid, audio/mpeg, ' +
              'audio/mp4, audio/x-aiff, audio/x-mpegurl, ' +
              'audio/vnd.rn-realaudio, audio/ogg, audio/vorbis, ' +
              'audio/vnd.wav, audio/mp3, ' +
              'image/jpeg, image/png'
            }
            createThumb
            ref={instance => {
              this.dropzone = instance && instance.getWrappedInstance();
            }}
            onFilesAdded={files => {
              this.setState({ fileCount: this.state.fileCount + files.length });
            }}
            onFileDeleted={_file =>
              this.setState({ fileCount: this.state.fileCount - 1 })
            }
            onFinishUpload={(file, thumb) => {
              this.props.addAsset(match.params.id, file, thumb);
            }}
            onHandleError={err => {
              console.log('onHandleError', err);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            disabled={this.state.fileCount <= 0}
            color="primary"
            onClick={() => {
              // console.log('dropzone', this.dropzone.uploadFiles());
              this.dropzone.uploadFiles();
            }}
          >
            Add
          </Button>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  addAsset: (campaignId, file, thumb) =>
    dispatch(addAsset(campaignId, file, thumb)),
});

const enhance = compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps
  )
);

export default enhance(AddAsset2);
